<template>
	<div>
		<!-- <div class="theme-light pb-3">
			<div class="container">
				<div class="row">
					<div
						v-if="currentStep !== 1 && (!getIsInvoiceCreated(formId)
							|| currentStep === 4 || getIsInvoiceTypeInvoice(formData.id))
							&& !getIsContactManager(formData.id)"
						class="col"
					>
						<div class="btn-panel text-right">
							<button
								v-if="isPreviousStepEnabled"
								class="btn btn-link"
								@click.prevent="previousStep"
							>
								Назад
							</button>
							<button
								v-if="currentStep !== 6"
								class="btn btn-outline-primary btn-save icon-save"
								@click.prevent="saveFormData"
							/>
							<button
								v-if="isNextStepEnabled"
								class="btn btn-primary"
								@click.prevent="nextStep"
							>
								Далее
							</button>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="prog_reg-footer">
			<div class="container">
				<div class="prog_reg-footer-wrap">
					<div class="row justify-content-between">
						<div class="col-12 col-sm-6 order-1 order-sm-0">
							<div class="btn-panel text-center text-sm-left">
								<a
									id="checkout_jivosite_top"
									onclick="jivo_api.open(); return false;"
									href="javascript:void(0)"
									class="btn btn-outline-primary"
									role="button"
								>
									Получить консультацию
								</a>
							</div>
						</div>

						<div
							v-if="currentStep !== 1
								//&& (!getIsInvoiceCreated(formId)
								//|| currentStep === 4 || getIsInvoiceTypeInvoice(formData.id))
								&& !getIsContactManager(formData.id)"
							class="col-12 col-sm-6 mb-3 mb-sm-0"
						>
							<div class="btn-panel text-center text-sm-right">
								<button
									v-if="isPreviousStepEnabled"
									class="btn btn-link"
									@click.prevent="previousStep"
								>
									Назад
								</button>
								<button
									v-if="currentStep !== 6"
									class="btn btn-outline-primary btn-save icon-save"
									@click.prevent="saveFormData"
								/>
								<button
									v-if="isNextStepEnabled"
									class="btn btn-primary"
									:disabled="loading"
									@click.prevent="nextStep"
								>
									<b-spinner
										v-if="loading"
										style="margin-right: 15px; width: 1.3em; height: 1.3em;"
									/>
									Далее
								</button>
								<div
									v-if="isErrorCookie"
									class="cookie-error"
								>
									Необходимо принять Cookies
								</div>
							</div>
						</div>
					</div>
					<b-container v-if="isValidate === false || isStepValid === false">
						<b-alert variant="danger" show class="d-flex justify-content-center mt-3 mb-3">
							Проверьте правильность введённых данных
						</b-alert>
					</b-container>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters, mapState, mapActions } from 'vuex';
import {
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
} from '@/store/checkout';
import checkoutForm from '@/mixins/checkoutForm';

export default {
	name: 'CheckoutFooter',
	mixins: [checkoutForm],

	props: {
		formId: {
			type: Number,
			default: null,
		},
		step: {
			type: Number,
			default: 1,
		},
		formData: {
			type: Object,
			default: () => ({}),
		},
		event: {
			type: Object,
			default: () => ({}),
		},
		isStepValid: {
			type: [Boolean, null],
			default: () => null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isValidate: null,
			isErrorCookie: false,
		};
	},
	computed: {
		currentStep() {
			return this.$store.getters['checkout/getStep'](this.formId);
		},
		...mapGetters({
			getIsInvoiceCreated: 'checkout/getIsInvoiceCreated',
			getIsContactManager: 'checkout/getIsContactManager',
			getIsInvoicePayment: 'checkout/getIsInvoicePayment',
			getIsShowDocumentInfoMessage: 'checkout/getIsShowDocumentInfoMessage',
			getIsInvoiceTypeInvoice: 'checkout/getIsInvoiceTypeInvoice',
			getOrderSatus: 'checkout/getOrderSatus',
		}),
		...mapState('cookiesDisclaimer', ['isCookiesAccepted']),
		isNextStepEnabled() {
			// Проверяем поменялись ли местами шаги или нет.
			if (!this.formData.reverse_step_4) {
				return !this.getIsShowDocumentInfoMessage(this.formData.id)
					&& ((this.isInvoicePayment && this.currentStep === 3)
						|| this.currentStep !== 3)
					&& !(this.formData.disable_step_4 === true
						&& this.currentStep === 3 && !this.getIsInvoicePayment(this.formData.id));
			}
			if (this.formData.disable_payment_until_chek_documents
				&& this.getOrderSatus(this.formData.id) == 0 && this.currentStep == 4) {
				return false;
			}
			return true;
		},
		isPreviousStepEnabled() {
			return this.currentStep > 1;
		},
	},
	methods: {
		...mapActions({
			dispatchShowCookiesDisclaimer: 'cookiesDisclaimer/show',
			dispatchHideCookiesDisclaimer: 'cookiesDisclaimer/hide',
		}),
		saveFormData() {
			this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formId });
		},
		async nextStep() {
			this.isValidate = null;
			if (!this.isCookiesAccepted) {
				this.isErrorCookie = true;
				await this.hideCookiesDisclaimer();
				this.showCookiesDisclaimer();
			} else {
				this.isErrorCookie = false;
				const currentStep = this.$store.getters['checkout/getStep'](this.formId);
				await this.$nextTick();
				if (currentStep !== 2) {
					this.$emit('clickStep', currentStep + 1);
				} else {
					const fields = this.$store.getters['checkout/getFormFields'](this.formId, this.formData.personNumber);
					this.checkValidation(fields.email);
					fields.landingId = this.formData.landing_id;
					fields.event = this.event && this.event.title ? this.event.title : null;
					if (this.isValidate) {
						this.$emit('clickStep', currentStep + 1);
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							event: 'form_send',
							form_data: fields,
						});
					}
				}
			}
		},
		checkValidation(val) {
			this.isValidate = this.validEmail(val);
		},
		validEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		async previousStep() {
			const currentStep = this.$store.getters['checkout/getStep'](this.formId);
			await this.$nextTick();
			this.$emit('clickStep', currentStep - 1);
		},
		showCookiesDisclaimer() {
			const isRejectable = false;
			this.dispatchShowCookiesDisclaimer(isRejectable);
		},
		hideCookiesDisclaimer() {
			this.dispatchHideCookiesDisclaimer();
		},
	},
};
</script>

<style scoped>

	.cookie-error {
		width: 100%;
    font-size: 100%;
		margin-top: 0.25rem;
    color: #dc3545;
	}
</style>
